var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _c("div", { staticClass: "col-md-6" }, [
          _c("div", { staticClass: "h2" }, [_vm._v(_vm._s(_vm.routeName))])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-2 offset-md-4 text-right center" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-primary",
                attrs: { to: "/admin/gifts", role: "button" }
              },
              [_vm._v("\n                        back\n                    ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.gift
        ? _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.update.apply(null, arguments)
                }
              }
            },
            [
              _c("div", { staticClass: "row justify-content-md-center" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.gifteeUuid,
                              expression: "rules.gifteeUuid"
                            }
                          ],
                          attrs: {
                            type: "text",
                            disabled: "",
                            label: "Code",
                            placeholder: "Enter Code",
                            "data-vv-name": "Code",
                            "cus-name": "Code",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.gift.gifteeUuid,
                            callback: function($$v) {
                              _vm.$set(_vm.gift, "gifteeUuid", $$v)
                            },
                            expression: "gift.gifteeUuid"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.packages.length
                      ? _c(
                          "div",
                          { staticClass: "col-4" },
                          [
                            _c("fg-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.rules.packageId,
                                  expression: "rules.packageId"
                                }
                              ],
                              attrs: {
                                disabled: "",
                                label: "Package",
                                "data-vv-name": "package",
                                "cus-name": "package",
                                "has-errors": _vm.errors,
                                "is-fields": _vm.fields,
                                list: _vm.packages,
                                selectedKey: "packageId"
                              },
                              model: {
                                value: _vm.gift.packageId,
                                callback: function($$v) {
                                  _vm.$set(_vm.gift, "packageId", $$v)
                                },
                                expression: "gift.packageId"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.corps.length
                      ? _c(
                          "div",
                          { staticClass: "col-4" },
                          [
                            _c("fg-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.rules.corporationId,
                                  expression: "rules.corporationId"
                                }
                              ],
                              attrs: {
                                disabled: "",
                                label: "Corporation",
                                "data-vv-name": "corporation",
                                "cus-name": "corporation",
                                "has-errors": _vm.errors,
                                "is-fields": _vm.fields,
                                list: _vm.corps,
                                selectedKey: "corporationId"
                              },
                              model: {
                                value: _vm.gift.corporationId,
                                callback: function($$v) {
                                  _vm.$set(_vm.gift, "corporationId", $$v)
                                },
                                expression: "gift.corporationId"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.customDateFlags.length
                      ? _c(
                          "div",
                          { staticClass: "col-4" },
                          [
                            _c("fg-select", {
                              attrs: {
                                label: "Gift Expiry Settings",
                                "is-fields": _vm.fields,
                                list: _vm.customDateFlags,
                                selectedKey: "id"
                              },
                              model: {
                                value: _vm.gift.trialExpiryDateType,
                                callback: function($$v) {
                                  _vm.$set(_vm.gift, "trialExpiryDateType", $$v)
                                },
                                expression: "gift.trialExpiryDateType"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.gift.trialExpiryDateType.toString() === "1"
                      ? _c(
                          "div",
                          { staticClass: "col-md-4" },
                          [
                            _c("label", [_vm._v("Set Expiry Date")]),
                            _vm._v(" "),
                            _c("datetime", {
                              attrs: {
                                required: "",
                                "input-class": "form-control",
                                placeholder: "Choose a Date",
                                type: "date",
                                "input-format": "DD-MM-YYYY",
                                "min-datetime": _vm.startDate,
                                "auto-continue": "",
                                required: ""
                              },
                              model: {
                                value: _vm.gift.trialEndDateCustom,
                                callback: function($$v) {
                                  _vm.$set(_vm.gift, "trialEndDateCustom", $$v)
                                },
                                expression: "gift.trialEndDateCustom"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c("fg-select", {
                          attrs: {
                            label: "User Validation Rules",
                            "is-fields": _vm.fields,
                            list: _vm.validationFlags,
                            selectedKey: "id"
                          },
                          model: {
                            value: _vm.gift.preValidate,
                            callback: function($$v) {
                              _vm.$set(_vm.gift, "preValidate", $$v)
                            },
                            expression: "gift.preValidate"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c("fg-select", {
                          attrs: {
                            label: "Interest Page After Signup",
                            "is-fields": _vm.fields,
                            list: _vm.interestFlags,
                            selectedKey: "id"
                          },
                          model: {
                            value: _vm.gift.skipInterestPage,
                            callback: function($$v) {
                              _vm.$set(_vm.gift, "skipInterestPage", $$v)
                            },
                            expression: "gift.skipInterestPage"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-5" },
                      [
                        _c("fg-input", {
                          attrs: {
                            type: "text",
                            label: "Default Landing Page after Singup",
                            placeholder:
                              "(e.g) /corporation/mycommunity or /mytone"
                          },
                          model: {
                            value: _vm.gift.landingPage,
                            callback: function($$v) {
                              _vm.$set(_vm.gift, "landingPage", $$v)
                            },
                            expression: "gift.landingPage "
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c("fg-input", {
                          attrs: {
                            type: "text",
                            label: "Redeem Button Tittle",
                            placeholder: "Redeem Button Title"
                          },
                          model: {
                            value: _vm.gift.button_label_01,
                            callback: function($$v) {
                              _vm.$set(_vm.gift, "button_label_01", $$v)
                            },
                            expression: "gift.button_label_01 "
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c("fg-select", {
                          attrs: {
                            label: "Trial Expiry Flags",
                            "is-fields": _vm.fields,
                            list: _vm.trialFlags,
                            selectedKey: "id"
                          },
                          model: {
                            value: _vm.gift.trialExpiryMsgFlag,
                            callback: function($$v) {
                              _vm.$set(_vm.gift, "trialExpiryMsgFlag", $$v)
                            },
                            expression: "gift.trialExpiryMsgFlag"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.gift.trialExpiryDateType === "1"
                      ? _c(
                          "div",
                          { staticClass: "col-md-4" },
                          [
                            _c("fg-select", {
                              attrs: {
                                label: "Trial Expiry Options",
                                "is-fields": _vm.fields,
                                list: _vm.triaOptions,
                                selectedKey: "id"
                              },
                              model: {
                                value: _vm.gift.giftTrialDateScope,
                                callback: function($$v) {
                                  _vm.$set(_vm.gift, "giftTrialDateScope", $$v)
                                },
                                expression: "gift.giftTrialDateScope"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-input", {
                          attrs: {
                            type: "text",
                            label: "Welcome Message",
                            placeholder: "Welcome Message"
                          },
                          model: {
                            value: _vm.gift.welcomeMessage,
                            callback: function($$v) {
                              _vm.$set(_vm.gift, "welcomeMessage", $$v)
                            },
                            expression: "gift.welcomeMessage "
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-input", {
                          attrs: {
                            type: "text",
                            label: "Gift Redeem Package Description",
                            placeholder: "Gift Redeem Package Description"
                          },
                          model: {
                            value: _vm.gift.signupGiftDesc,
                            callback: function($$v) {
                              _vm.$set(_vm.gift, "signupGiftDesc", $$v)
                            },
                            expression: "gift.signupGiftDesc "
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-input", {
                          attrs: {
                            type: "text",
                            label: "Panel Title",
                            placeholder: "Panel Title"
                          },
                          model: {
                            value: _vm.gift.panelHeading1,
                            callback: function($$v) {
                              _vm.$set(_vm.gift, "panelHeading1", $$v)
                            },
                            expression: "gift.panelHeading1 "
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-input", {
                          attrs: {
                            type: "text",
                            label: "Panel Description",
                            placeholder: "Panel Description"
                          },
                          model: {
                            value: _vm.gift.panelHeading2,
                            callback: function($$v) {
                              _vm.$set(_vm.gift, "panelHeading2", $$v)
                            },
                            expression: "gift.panelHeading2 "
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-input", {
                          attrs: {
                            type: "text",
                            label: "Panel Bullet 1 Text",
                            placeholder: "Panel Bullet 1 Text"
                          },
                          model: {
                            value: _vm.gift.panelBullet1,
                            callback: function($$v) {
                              _vm.$set(_vm.gift, "panelBullet1", $$v)
                            },
                            expression: "gift.panelBullet1 "
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-input", {
                          attrs: {
                            type: "text",
                            label: "Panel Bullet 2 Text",
                            placeholder: "Panel Bullet 2 Text"
                          },
                          model: {
                            value: _vm.gift.panelBullet2,
                            callback: function($$v) {
                              _vm.$set(_vm.gift, "panelBullet2", $$v)
                            },
                            expression: "gift.panelBullet2 "
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-input", {
                          attrs: {
                            type: "text",
                            label: "Panel Bullet 3 Text",
                            placeholder: "Panel Bullet 3 Text"
                          },
                          model: {
                            value: _vm.gift.panelBullet3,
                            callback: function($$v) {
                              _vm.$set(_vm.gift, "panelBullet3", $$v)
                            },
                            expression: "gift.panelBullet3 "
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-input", {
                          attrs: {
                            type: "text",
                            label: "Panel Bullet 4 Text",
                            placeholder: "Panel Bullet 4 Text"
                          },
                          model: {
                            value: _vm.gift.panelBullet4,
                            callback: function($$v) {
                              _vm.$set(_vm.gift, "panelBullet4", $$v)
                            },
                            expression: "gift.panelBullet4 "
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-input", {
                          attrs: {
                            type: "text",
                            label: "Panel Bullet 5 Text",
                            placeholder: "Panel Bullet 5 Text"
                          },
                          model: {
                            value: _vm.gift.panelBullet5,
                            callback: function($$v) {
                              _vm.$set(_vm.gift, "panelBullet5", $$v)
                            },
                            expression: "gift.panelBullet5 "
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-input", {
                          attrs: {
                            type: "text",
                            label: "Panel Bullet 6 Text",
                            placeholder: "Panel Bullet 6 Text"
                          },
                          model: {
                            value: _vm.gift.panelBullet6,
                            callback: function($$v) {
                              _vm.$set(_vm.gift, "panelBullet6", $$v)
                            },
                            expression: "gift.panelBullet6 "
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 text-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-fill btn-block",
                      attrs: { type: "submit", disabled: _vm.errors.any() }
                    },
                    [
                      _vm._v(
                        "\n                    Edit Gift\n                  "
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" })
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09dba192", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09dba192","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Gifts/EditGift.vue
// module id = rW1H
// module chunks = 0